import { BrandProfileDocumentsProps } from './Types'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { Dropzone } from './Dropzone'
import { Table } from './Table'
import { collectResults } from 'utils/query'
import { Button } from 'blaze-ui/Button'
import { ArrowLeft, ArrowRight, ArrowSkip } from 'blaze-ui/icons'
import Styles from './BrandProfileDocuments.module.scss'
import { FooterButtons, StickyFooter } from 'components/FirstTimeExperienceModal/components/Footer/Footer'
import VirtualMarketerOnboardingStyles from 'screens/VirtualMarketerOnboarding/VirtualMarketerOnboarding.module.scss'
import { StickyFooterProvider } from 'providers/StickyFooterProvider/StickyFooterProvider'
import { useState } from 'react'
import { ACCEPTED_IMAGE_MIME_TYPES_NO_SVG } from 'screens/Finder/components/views/GalleryView/constants'
import { useBrandKitSources } from 'hooks/queries/useBrandKitSources'
import { useBrandProfile } from 'hooks/queries/brandProfiles/useBrandProfile'

export const BRAND_PROFILE_SUPPORTED_FILE_TYPES = `${ACCEPTED_IMAGE_MIME_TYPES_NO_SVG},application/pdf`

const BrandProfileDocuments = ({ id, onBack, onSkip, onNext }: BrandProfileDocumentsProps) => {
  const [isCreatingAnalysis, setIsCreatingAnalysis] = useState(false)

  const brandKitId = useBrandProfile(id)?.data?.brand_kit.id
  const documentsQuery = useBrandKitSources(
    {
      brandKitId: brandKitId ?? -1,
      sourceType: ['SourceMaterialsMediaObject'],
    },
    {
      enabled: !!brandKitId,
    },
  )
  const documents = collectResults(documentsQuery, (data) => data.brand_kit_sources)

  const handleSkip = async () => {
    setIsCreatingAnalysis(true)
    onSkip()
  }

  const handleNext = async () => {
    setIsCreatingAnalysis(true)
    onNext()
  }

  return (
    <MultiStepStepLayout
      title="Upload Brand Materials"
      description="Share anything that explains what you do—product sheets, case studies, presentations. Upload screenshots from social media or other pages so your AI marketer can describe your products and services."
      scrollContainerClassName={VirtualMarketerOnboardingStyles.scrollContainer}
      contentClassName={VirtualMarketerOnboardingStyles.content}
    >
      <StickyFooterProvider
        footer={
          <StickyFooter>
            <FooterButtons>
              <Button variant="tertiary" size="xl" onPress={onBack} frontIcon={ArrowLeft} aria-label="Back">
                Back
              </Button>
              <div className={Styles.footerRightButtons}>
                {documents.length === 0 && (
                  <Button
                    variant="tertiary"
                    size="xl"
                    isDisabled={isCreatingAnalysis}
                    onPress={handleSkip}
                    endIcon={ArrowSkip}
                    aria-label="Skip"
                  >
                    Skip
                  </Button>
                )}
                <Button
                  size="xl"
                  isDisabled={isCreatingAnalysis || documents.length === 0}
                  onPress={handleNext}
                  endIcon={ArrowRight}
                  aria-label="Continue"
                >
                  Continue
                </Button>
              </div>
            </FooterButtons>
          </StickyFooter>
        }
      >
        <div className={Styles.documents}>
          <div>
            {documents.length === 0 && !!brandKitId ? <Dropzone brandKitId={brandKitId} /> : null}
            {documents.length > 0 && !!brandKitId ? <Table brandKitId={brandKitId} /> : null}
          </div>
        </div>
      </StickyFooterProvider>
    </MultiStepStepLayout>
  )
}

export { BrandProfileDocuments }
